{
  "name": "chancenwerk",
  "displayName": "Adornis Starter Kit",
  "description": "Base for everything",
  "version": "4.0.1",
  "private": true,
  "type": "module",
  "scripts": {
    "preinstall": "npx only-allow pnpm",
    "start": "adornis-build workspace start",
    "eslint": "npx eslint . --ext .ts --parser @typescript-eslint/parser",
    "eslint-fix": "npx eslint --fix . --ext .ts --parser @typescript-eslint/parser",
    "test": "pnpm -r --workspace-concurrency=1 test; junit-merge -o junit.xml ./chancenanmeldung/test-results.xml ./chancenboard/test-results.xml ./chancencampus/test-results.xml ./chancennetz/test-results.xml ./chancenraum/test-results.xml",
    "test:puppeteer": "adornis-build project test --serverPath src/server -o dist/test --listenPort 9999 --nodePort 10000 --inspectPort 10001 --hotReloadPort 10002 --no-production --ignoreDefaults",
    "updateSkeleton": "bash -c \"$(curl https://static.adornis.de/scripts/pull-skeleton.sh)\"",
    "switchModule": "bash deploy/module.sh",
    "update-adornis": "npx npm-check-updates --target greatest @adornis/*"
  },
  "dependencies": {
    "@adornis/action-picker": "^8.0.13",
    "@adornis/address": "^15.0.30",
    "@adornis/adornis-components": "^15.1.33",
    "@adornis/analytics": "^16.0.25",
    "@adornis/ass": "^10.1.13",
    "@adornis/authentication": "^16.3.6",
    "@adornis/base": "^12.1.0",
    "@adornis/baseql": "^14.2.1",
    "@adornis/buildify": "^8.1.28",
    "@adornis/calendar": "^14.1.1",
    "@adornis/charts": "^15.0.30",
    "@adornis/chat": "^19.0.10",
    "@adornis/chemistry": "^14.2.0",
    "@adornis/cms": "^21.0.51",
    "@adornis/config": "^10.4.4",
    "@adornis/counter": "^14.0.16",
    "@adornis/data-view": "^21.3.4",
    "@adornis/datetime": "^18.0.37",
    "@adornis/dialog": "^14.3.4",
    "@adornis/dms": "^5.0.51",
    "@adornis/dragdrop": "^14.0.26",
    "@adornis/duplicate-merger": "^7.0.51",
    "@adornis/entity-picker": "^5.0.44",
    "@adornis/excalidraw": "^5.0.36",
    "@adornis/field-management": "^5.1.26",
    "@adornis/file-utils": "^15.1.4",
    "@adornis/filter": "^5.4.0",
    "@adornis/fonts": "^14.0.26",
    "@adornis/formfield": "^14.0.26",
    "@adornis/forms": "^18.0.29",
    "@adornis/functional-lit": "^2.2.17",
    "@adornis/html-based-buildify": "^7.2.33",
    "@adornis/http-proxy": "^10.1.11",
    "@adornis/import-export": "^18.0.37",
    "@adornis/internationalization": "^19.0.36",
    "@adornis/llm": "^20.2.1",
    "@adornis/mails": "^20.1.6",
    "@adornis/materialized-views": "^4.0.51",
    "@adornis/pagination": "^15.0.25",
    "@adornis/popover": "^18.0.36",
    "@adornis/print": "^15.0.30",
    "@adornis/router": "^4.4.7",
    "@adornis/speech": "^18.0.37",
    "@adornis/ssr": "^12.0.12",
    "@adornis/templater": "^0.3.8",
    "@adornis/tiptap": "^6.0.36",
    "@adornis/todo": "^6.0.37",
    "@adornis/translation": "^6.0.37",
    "@adornis/translation-core": "^5.0.12",
    "@adornis/user-forms": "^16.0.47",
    "@adornis/users": "^16.1.5",
    "@adornis/validation": "^10.5.0",
    "@adornis/versioned-entity": "^6.0.36",
    "@adornis/wiki": "^10.0.37",
    "@adornis/writer": "^18.0.37",
    "@adornis/view-manager": "^0.1.15",
    "@hotosm/iso-countries-languages": "^1.1.2",
    "@lit-labs/motion": "^1.0.8",
    "@lit-labs/preact-signals": "^1.0.3",
    "@lit/context": "^1.1.4",
    "@lumieducation/h5p-express": "9.0.6",
    "@lumieducation/h5p-server": "9.0.6",
    "@lumieducation/h5p-webcomponents": "9.0.6",
    "@navsnpm/katex-expression": "^1.1.0",
    "@openreplay/tracker": "^15.0.3",
    "@serlo/editor-web-component": "^0.13.2",
    "@tinymce/tinymce-webcomponent": "^2.1.0",
    "@types/js-cookie": "^3.0.6",
    "axios": "^1.7.9",
    "construct-style-sheets-polyfill": "^3.1.0",
    "cookie-parser": "^1.4.7",
    "cors": "^2.8.5",
    "date-fns": "^4.1.0",
    "debug": "^4.4.0",
    "docxtemplater-image-module-free": "^1.1.1",
    "emitter": "^0.0.5",
    "express": "^4.21.2",
    "express-fileupload": "^1.5.1",
    "fs-extra": "^11.3.0",
    "graphql": "^16.10.0",
    "graphql-voyager": "^2.1.0",
    "iframe-resizer": "^5.3.3",
    "js-cookie": "^3.0.5",
    "libreoffice-convert": "^1.6.0",
    "lit": "^3.2.1",
    "luxon": "^3.5.0",
    "markdown-it": "^14.1.0",
    "mingo": "6.5.3",
    "mongodb": "^6.13.1",
    "needle": "^3.3.1",
    "node-schedule": "^2.1.1",
    "pino": "^9.6.0",
    "prom-client": "^15.1.3",
    "puppeteer": "^24.2.1",
    "qrcode": "^1.5.4",
    "redis": "^4.7.0",
    "rxjs": "^7.8.2",
    "smiles-drawer": "^2.1.7",
    "string-similarity": "^4.0.4",
    "tinymce": "^7.7.0",
    "ts-prune": "^0.10.3",
    "why-is-node-running": "^3.2.2"
  },
  "devDependencies": {
    "@adornis/esbuild": "^13.1.3",
    "@adornis/testing": "^15.0.4",
    "@playwright/test": "1.50.1",
    "@types/busboy": "^1.5.4",
    "@types/cache-manager": "^4.0.6",
    "@types/cookie-parser": "^1.4.8",
    "@types/cors": "^2.8.17",
    "@types/iframe-resizer": "^4.0.0",
    "@types/luxon": "^3.4.2",
    "@types/mocha": "^10.0.10",
    "@types/multer": "^1.4.12",
    "@types/needle": "^3.3.0",
    "@types/node": "^22.13.4",
    "@types/node-schedule": "^2.1.7",
    "@types/qrcode": "^1.5.5",
    "@typescript-eslint/eslint-plugin": "^8.24.1",
    "@typescript-eslint/parser": "^8.24.1",
    "c8": "^10.1.3",
    "eslint": "^9.20.1",
    "eslint-config-prettier": "^10.0.1",
    "eslint-config-standard-with-typescript": "^43.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-n": "^17.15.1",
    "eslint-plugin-promise": "^7.2.1",
    "junit-merge": "^2.0.0",
    "mocha": "^11.1.0",
    "mocha-junit-reporter": "^2.2.1",
    "playwright": "1.50.1",
    "typescript": "^5.7.3"
  },
  "files": [
    "chancen*/dist"
  ],
  "license": "ISC",
  "@adornis/esbuild": {
    "server-path": "./src/server",
    "output-path": "dist/tests",
    "listenPort": 56000,
    "nodePort": 56001,
    "hotReloadPort": 56002,
    "inspectPort": 56003,
    "production": false,
    "ignoreDefaults": true
  },
  "packageManager": "pnpm@9.3.0+sha512.ee7b93e0c2bd11409c6424f92b866f31d3ea1bef5fbe47d3c7500cdc3c9668833d2e55681ad66df5b640c61fa9dc25d546efa54d76d7f8bf54b13614ac293631"
}
